export enum TipoEstoqueNegociado {

	ESTOQUE_VAZIO = <any>'estoqueNegociado:vazio',
	ESTOQUE_CHEIO = <any>'estoqueNegociado:cheio',
	TODOS = <any>'estoqueNegociado:todos'
}